// extracted by mini-css-extract-plugin
export default {"cargo-dropdown":"CargoDropdown_cargo-dropdown__OcXMn","label":"CargoDropdown_label__pP7kU"};